import { FC } from 'react';
import styled, { css } from 'styled-components';
import CardMedia from './base/card-media';
import CardHeader from './base/card-header';
import CardHorizontalBlock from './base/card-horizontal-block';
import Card, { CardLayout } from './base/card';
import CardBody from './base/card-body';
import { CardTypes } from './card-types';

interface Props {
	mediaWithoutFlex?: string;
}

const HorizontalCardContent = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	/* hack to fix a known limitation when using ellipsis with flexbox */
	min-width: 0;
`;
const HorizontalCardMedia = styled.div<Props>`
	display: flex;
	flex: 0 0 60%;
	${({ mediaWithoutFlex }) =>
		mediaWithoutFlex &&
		css`
			flex: none;
		`};
`;

const HorizontalCardIconWrapper = styled.div`
	position: absolute;
	top: 12px;
	right: 12px;
	svg {
		fill: rgba(var(--open-in-new-window-icon, var(--primary)), 1);
	}
`;

const HorizontalCardBottom = styled.div`
	flex-basis: 100%;
	height: 100%;
`;

const HorizontalCard: FC<CardTypes> = ({
	cardMediaSrc,
	cardMediaSrcSet,
	cardMediaLazyload,
	cardMediaIconRight,
	cardMediaChipText,
	cardMediaChipIcon,
	cardMediaPillContent,
	onCardMediaClick,
	cardHeaderTitle,
	cardHeaderCaption,
	cardHeaderTitleEllipsis,
	cardHeaderCaptionEllipsis,
	cardHeaderActionContent,
	cardFooterContent,
	cardBodyContent,
	cardMediaBannerText,
	cardMediaImageComponent,
	cardMediaChipTextDataAt,
	cardMediaChipIconDataAt,
	dataAt,
	dataTestId,
	overflow,
	mediaWithoutFlex,
	biggerBorderRadius,
	cardTopRightIcon,
	cardBottomContent,
	cardWrap
}) => (
	<Card
		cardLayout={CardLayout.HORIZONTAL}
		data-at={dataAt}
		data-testid={dataTestId}
		overflow={overflow}
		biggerBorderRadius={biggerBorderRadius}
		cardWrap={cardWrap}
	>
		<HorizontalCardMedia mediaWithoutFlex={mediaWithoutFlex}>
			<CardMedia
				src={cardMediaSrc}
				srcSet={cardMediaSrcSet}
				onClick={onCardMediaClick}
				pillContent={cardMediaPillContent}
				iconRight={cardMediaIconRight}
				bannerText={cardMediaBannerText}
				lazyload={cardMediaLazyload}
				chipText={cardMediaChipText}
				chipIcon={cardMediaChipIcon}
				imageComponent={cardMediaImageComponent}
				dataAt={cardMediaChipTextDataAt}
				iconDataAt={cardMediaChipIconDataAt}
			/>
		</HorizontalCardMedia>
		<HorizontalCardContent>
			{cardHeaderTitle || cardHeaderCaption ? (
				<CardHeader
					title={cardHeaderTitle}
					caption={cardHeaderCaption}
					actionContent={cardHeaderActionContent}
					headerTitleEllipsis={cardHeaderTitleEllipsis}
					headerCaptionEllipsis={cardHeaderCaptionEllipsis}
				/>
			) : null}

			{cardBodyContent && <CardBody>{cardBodyContent}</CardBody>}
			{cardFooterContent && (
				<CardHorizontalBlock showGuttersTop showGuttersBetween>
					{cardFooterContent}
				</CardHorizontalBlock>
			)}
		</HorizontalCardContent>
		{cardBottomContent ? <HorizontalCardBottom>{cardBottomContent}</HorizontalCardBottom> : null}

		{cardTopRightIcon ? <HorizontalCardIconWrapper>{cardTopRightIcon}</HorizontalCardIconWrapper> : null}
	</Card>
);

export default HorizontalCard;
